// @ts-ignore
import { themes } from "ksc-portal-shareable-configs/dist/webpack/webpack-foundation/constants"
// @ts-ignore
import { makePutRequest as putRequest } from "../../utils/lambda/requests"
import {
  LEGAL_CONST,
  TERMS_AND_CONDITIONS,
  TERMS_AND_CONDITIONS_URL,
} from "./constants"
import { ModuleTC, OutstandingTC, Theme, LLModule, Tcs } from "./types"

export const SRB_LL_CONST = "srb-ll"

export default class TC {
  themes: Theme[]

  history: object

  outstanding: OutstandingTC[]

  outstandingThemes: OutstandingTC[]

  moduleList: ModuleTC[]

  themeIds: string[]

  themeModules: ModuleTC[]

  nonThemeModules: ModuleTC[]

  hubModule: ModuleTC[]

  nonHubThemeModules: ModuleTC[]

  linklaters: LLModule[]

  constructor({ tc, history }: { tc: Tcs; history: object }) {
    this.history = history
    this.outstanding = TC.setOutstanding(tc)
    this.outstandingThemes = this.outstanding.filter(({ standardId }) =>
      themes.some(({ theme }: { theme: string }) => theme === standardId)
    )
    this.themes = TC.setThemes()
    this.moduleList = Object.entries(tc).map(([id, data]) => ({
      id,
      ...data,
    }))
    this.themeIds = themes.map(({ theme }: Theme) =>
      theme === "kr" ? "hub" : theme
    )
    this.themeModules = this.moduleList.filter(({ id }) =>
      this.themeIds.includes(id)
    )
    this.nonThemeModules = this.moduleList.filter(
      ({ id }) => !this.themeIds.includes(id) && id !== SRB_LL_CONST
    )
    this.hubModule = this.moduleList.filter(({ id }) => id === "hub")
    this.nonHubThemeModules = this.themeModules.filter(({ id }) => id !== "hub")
    this.linklaters = [
      ...(this.moduleList.map(({ id }) => id).includes(SRB_LL_CONST)
        ? [{ name: "Linklaters", id: SRB_LL_CONST }]
        : []),
    ]
  }

  linklatersAccepted(): boolean {
    return !this.isModuleOutstanding(SRB_LL_CONST)
  }

  static cleanUrl(url: string): string {
    return url.split(" ").join("-").toLowerCase()
  }

  isModuleOutstanding(moduleId: string): boolean {
    return this.outstanding.some(({ id }) => id === moduleId)
  }

  static setOutstanding(modules: Tcs): OutstandingTC[] {
    return Object.entries(modules)
      .map(([id, mod]) => ({
        id,
        standardId: id === "hub" ? "kr" : id,
        ...mod,
      }))
      .filter(({ accepted }) => !accepted)
  }

  static hubTCUrl(): string {
    return TC.themeTCUrl("kaizen hub")
  }

  nextOutstandingUrl(): string {
    const [{ name }] = this.outstanding
    /*
    If the outstanding module is not also a theme, redirect to
    the kaizen hub's module's terms and conditions
     */
    if (
      !themes
        .map(({ title }: { title: string }) => title.toLowerCase())
        .concat("linklaters")
        .includes(name.toLowerCase())
    )
      return TC.moduleTCUrl(`kaizen hub/${name}`)
    // if ll haven't accepted - redirect to the ll terms and conditions
    if (!this.linklatersAccepted()) return TC.themeTCUrl("linklaters")
    // this final case is for TCs that are themes
    return TC.themeTCUrl(name)
  }

  acceptTC(moduleId: string): void {
    const [{ latest_version }] = this.moduleList.filter(
      ({ id }) => id === moduleId
    )
    putRequest({
      url: `${TERMS_AND_CONDITIONS_URL}/${moduleId}/${latest_version}`,
      onSuccess: () => {
        this.outstanding = this.outstanding.filter(({ id }) => id !== moduleId)
        this.outstandingThemes = this.outstandingThemes.filter(
          ({ id }) => id !== moduleId
        )
        this.history.push(
          this.userHasAcceptedAllThemeTCs()
            ? "/home"
            : this.nextOutstandingUrl()
        )
        window.scrollTo(0, 0)
      },
      onFailure: console.error,
    })
  }

  logout(): void {
    this.history.push("/logout")
  }

  rejectTC(moduleId: string): void {
    // if outstanding themes contains module id, logout
    if (
      this.outstandingThemes
        .map(({ id }) => id)
        .concat(SRB_LL_CONST)
        .includes(moduleId)
    )
      this.logout()
    // else if outstanding themes has length and that theme is not the one that's just been rejected,
    // redirect to outstanding theme. Otherwise logout
    else if (this.outstandingThemes.length) {
      const nextUrl = this.nextOutstandingUrl()
      if (nextUrl === window.location.pathname) this.logout()
      else this.history.push(nextUrl)
    }
    // else send home
    else this.history.push("/home")
  }

  userHasAcceptedAllThemeTCs(): boolean {
    return this.outstandingThemes.length === 0 && this.linklatersAccepted()
  }

  userHasAcceptedAllModuleTCs(): boolean {
    return this.outstanding.length === 0
  }

  getTCStatus(moduleId: string): boolean {
    return this.outstanding.some(({ id }) => moduleId === id)
  }

  static themeTCUrl(title: string): string {
    return TC.cleanUrl(`/${LEGAL_CONST}/${title}/${TERMS_AND_CONDITIONS}`)
  }

  static moduleTCUrl(title: string): string {
    return TC.cleanUrl(`/${LEGAL_CONST}/${title}`)
  }

  static setThemes(): Theme[] {
    return themes.map(({ theme, ...rest }: Theme) => ({
      theme: theme === "kr" ? "hub" : theme,
      ...rest,
    }))
  }
}
